import { createContext } from 'react';
import { DiscadorContextProps } from '../props';

export const DiscadorContext = createContext<DiscadorContextProps>({} as DiscadorContextProps);
